import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { ProfileModel } from '../models/profile.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';
 
@Injectable({
  providedIn: 'root',
})

export class ProfileDetailsResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private homeService:HomeService, private auth:AuthenticationService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    const ownerId = route.paramMap.get('profileId');
    const itemId = route.paramMap.get('itemId');
    const role = route.data.itemRole;
    const user = await this.auth.getUser();
    const newItem = <ProfileModel>{
      status:'new',
      role:role,
      owner:{
        key:ownerId
      },
      details:{
        role:role,
        geocoding:{
          address:{
            postalCode:null,
            countryCode:null,
            city:null,
            houseNumber:null,
          }
        },
        fullProfile:false,
        shortDetails:{
          name:null
        },
        fullDetails:{
          firstname:null,
          lastname:null,
          phone:null
        },
        labels: {
          bio: false,
          bioConversion:false,
          labelRouge:false,
          aop:false,
          igp:false,
          pecheDurable:false
        }
      },
      private:{
        notifications:{
          newTournee:{
            email:true,
            app:true,
          }
        }
      }
    };
    if(itemId == undefined || itemId == 'new'){
      console.log('new '+ role,newItem, itemId);
      return newItem;
    }
    else if(role=='reseller'){
      const item = await firstValueFrom(this.dataService.getProducerReseller(itemId,ownerId))
      if (item && Object.keys(item).length>0) {
        const profile:ProfileModel = {
          key:itemId,
          role:role,
          details:item.details,
          owner:{
            key:ownerId
          }
        }
        return profile;
      } else { // id not found
        if(user.role=='admin'){
          return newItem;
        }
        else{
          this.homeService.navigateToHome('unknown');
        }
      }
    }
    else if(role=='producer'){
      const details = await firstValueFrom(this.dataService.getProducerDetails(itemId));
      if (details && Object.keys(details).length>0) {
        const profile:ProfileModel = {
          key:itemId,
          role:role,
          details:details,
          owner:{
            key:ownerId
          }
        }
        return profile;
      } else { // id not found
        if(user.role=='admin'){
          return newItem;
        }
        else{
          this.homeService.navigateToHome('unknown');
        }
      }
    }
  }
}